// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"7cdaa495","166":"e452cdd5","268":"feb26494","407":"4d175835","520":"eaf35c3e","521":"3325c818","815":"b130d4b6","865":"cd6cb726","885":"6d7a8142"}[chunkId] + ".chunk.js";
};